import { DateTime } from 'luxon';
import wordDeclension from './word-declension';

export interface Countdown {
  date: number;
  text?: string;
  progress?: string;
  action_text?: string;
}

export const countdownInit = (
  dateList: DateTime<boolean>[],
  countdownType: string
): Countdown | null => {
  if (
    !dateList ||
    !dateList.length ||
    countdownType === 'unset' ||
    !countdownType
  ) {
    return null;
  }

  const date = (
    {
      manual: () => dateList[0].valueOf() - Date.now(),
      untilStart: () => dateList[0].valueOf() - Date.now(),
      untilEnd: () => dateList[dateList.length - 1].valueOf() - Date.now(),
      untilNearest: () => {
        const futureDates = dateList.filter(
          (dateItem) => dateItem.valueOf() - Date.now() > 0
        );
        if (futureDates.length) {
          return futureDates[0].valueOf() - Date.now();
        }
        return null;
      },
    } as { [key: string]: (() => number) | (() => number | undefined) }
  )[countdownType]();

  if (!date) {
    return null;
  }

  const countdown: Countdown = {
    date,
  };

  // счетчик не нужен если больше 7 суток
  const msInWeek = 7 * 24 * 60 * 60 * 1000;
  if (!countdown.date || countdown.date > msInWeek || countdown.date < 0) {
    // eslint-disable-next-line consistent-return
    return null;
  }

  if (!countdown.date || countdown.date > msInWeek || countdown.date < 0) {
    return null;
  }

  countdown.date -= 1000;
  let t = countdown.date / 1000;

  countdown.progress = (((msInWeek - countdown.date) / msInWeek) * 100).toFixed(
    2
  );

  const days = Math.floor(t / 86400);
  t -= days * 86400;
  const hours = Math.floor(t / 3600) % 24;
  t -= hours * 3600;
  const minutes = Math.floor(t / 60) % 60;
  t -= minutes * 60;
  const seconds = Math.floor(t % 60);

  const [hoursText, minutesText, secondsText] = [hours, minutes, seconds].map(
    (dateNum) => dateNum.toString().padStart(2, '0')
  );

  const daySubstr = wordDeclension(days, 'день', 'дня', 'дней');
  const hoursSubstr = wordDeclension(hours, 'час', 'часа', 'часов');
  const minutesSubstr = wordDeclension(minutes, 'минута', 'минуты', 'минут');
  const secondsSubstr = wordDeclension(seconds, 'секунда', 'секунды', 'секунд');

  if (days) {
    countdown.action_text = `${days} ${daySubstr}`;
    if (hours) {
      countdown.action_text += ` ${hours} ${hoursSubstr}`;
    }
  } else if (hours) {
    countdown.action_text = `${hours} ${hoursSubstr}`;
    if (minutes) {
      countdown.action_text += ` ${minutes} ${minutesSubstr}`;
    }
  } else if (minutes) {
    countdown.action_text = `${minutes} ${minutesSubstr}`;
    if (seconds) {
      countdown.action_text += ` ${seconds} ${secondsSubstr}`;
    }
  } else if (seconds) {
    countdown.action_text = `${seconds} ${secondsSubstr}`;
  } else {
    countdown.action_text = '';
  }

  countdown.text =
    (days ? `${days} ${daySubstr} ` : '') +
    [hoursText, minutesText, secondsText].join(':');

  return countdown;
};
